import BaseController from "confinus_ui/base_controller";

export default class DeliveryDateSelectController extends BaseController {
  public static targets = ["form"];
  declare private readonly formTarget: HTMLFormElement;

  public dateSelected(evt: Event) {
    evt.stopPropagation();
    this.formTarget.submit();
  }
}
